export default {
	title: "Ritual Types",
	spiritualLine: "Spiritual Line",
	status: "Status",
	details: {
		basicInfo: "Basic Information",
		timestamps: "System Information",
		noData: "No data available",
	},
	edit: "Edit Ritual Type",
	create: "Create Ritual Type",
	activate: "Activate",
	deactivate: "Deactivate",
	notFound: "Ritual type not found",
	deleteConfirmation: "Do you really want to delete the ritual type {name}?",
	form: {
		nameLabel: "Ritual Type Name",
		nameHint: "Name that identifies the ritual type",
		codeLabel: "Code",
		codeHint: "Filled in from the name — change it only if you want another",
		descriptionLabel: "Description",
		descriptionHint: "Optional description of the ritual type",
		spiritualLineLabel: "Predominant Spiritual Line",
		spiritualLineHint: "Spiritual line that predominates in this ritual type",
		isActiveLabel: "Type active in the system",
	},
	validation: {
		nameRequired: "Name is required",
		nameMaxLength: "Name must have at most 100 characters",
		codeRequired: "Code is required",
		codeMaxLength: "Code must have at most 50 characters",
		codeFormat: "Code must contain only lowercase letters, numbers, hyphens and underscores",
		spiritualLineRequired: "Spiritual line is required",
		descriptionMaxLength: "Description must have at most 500 characters",
	},
	messages: {
		created: "Ritual type {name} created successfully",
		updated: "Ritual type {name} updated successfully",
		deleted: "Ritual type {name} deleted successfully",
		deactivatedWithDeps: "Ritual type {name} has dependencies and was deactivated",
		activated: "Ritual type {name} activated successfully",
		deactivated: "Ritual type {name} deactivated successfully",
		createError: "Error creating ritual type",
		updateError: "Error updating ritual type",
		deleteError: "Error deleting ritual type",
		loadError: "Error loading ritual types",
		toggleError: "Error changing ritual type status",
	},
	noDescription: "No description",
	searchPlaceholder: "Name, code or description...",
	loading: "Loading details...",
	table: {
		name: "Name",
		spiritualLine: "Spiritual Line",
		attendanceCards: "Cards",
		status: "Status",
		headers: {
			createdAt: "Created at",
			updatedAt: "Updated at",
		},
	},
	empty: {
		description: "Register the types of rituals practiced in the temple",
		title: "No ritual types found",
	},
	filters: {
		status: {
			all: "All",
		},
	},
	stats: {
		total: "Total Types",
		active: "Active Types",
	},
};
